import axios from "axios"

const service = axios.create({
	baseURL: process.env.BASE_URL,
    // baseURL:'http://192.168.1.92:8229/jeecg-boot/',
  timeout: 40000
})

service.interceptors.request.use(
  config => {
    config.headers = Object.assign({'APPOINTMENT-SOURCE': encodeURIComponent("网站")}, config.headers || {})
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
		return response
  },
  error => {
    return Promise.reject(error)
  }
)

export default service


// WEBPACK FOOTER //
// ./src/axios/index.js